(function( $ ) {

"use strict";


var evt_to_marker = function(id,over)
{
    var m = markerarray[id];

	if (m.getAnimation() == null) {
	    m.setAnimation(google.maps.Animation.BOUNCE);
	} else {
	    m.setAnimation(null);
	}
}

function hide_searchoverlay(event) {

	event.stopPropagation();
	$('html').on('click',function(e) {

		if($('.title-wrapper').hasClass('active') && $('.input-active').length > 0)
			$('.title-wrapper').removeClass('active');

	});

	$(window).scroll(function() {
		$('.datepicker-field').datepicker('hide');
		$('.title-wrapper').removeClass('active');
	});
}

$(document).ready(function(){

	// sticky menu
	var offset = 0;
	if($('.logged-in').length > 0)
		offset = 32;

	// Menu mobile trigger
	$('.btn-menu-mobile-trigger').on('click', function(){
		$('.menu-mobile').toggleClass('active');
	});

	// search modal
	$(document).on('click','.search-toggle',

		function(e)
		{
			e.preventDefault();

			$('#modal-search .search-field').val('');

			// Show modal
			$('#modal-search').modal();

			// Add focus to search field
			$('#modal-search').off('shown.bs.modal');
			$('#modal-search').on('shown.bs.modal', function() {
    			$('#modal-search .search-field').focus();
			});
		}

	);

	if($(window).width() > 768){
        $(".site-header").stick_in_parent({
            offset_top:offset - 1,
        });
    } else {
        var distance = $('.site-header').offset().top,
            $window = $(window);

        $window.scroll(function() {
            if ( $window.scrollTop() > distance ) {
                $('.site-header').addClass('is_stuck');
            } else {
                $('.site-header').removeClass('is_stuck');
            }
        });
	}
	
	// news on HP
	if($(window).width() > 768){
		if($('body').hasClass('home')){
			$('#allnews .big-square,#allnews .rectangle').matchHeight();
		}
	}
	
	// event slider on HP
	$('.slider-soon-wrapper').slick({
	  	centerMode: true,
  		//autoplay: true,
  		autoplaySpeed: 4000,
  		pauseOnFocus:false,
  		pauseOnHover:false,
  		centerPadding: '167px',
	  	slidesToShow: 5,
	  	slidesToScroll: 3,
	  	responsive: [
	    {
	      breakpoint: 1550,
	      settings: {
	        //arrows: false,
	        centerMode: true,
	        //centerPadding: '0px',
	        slidesToShow: 4,
	        slidesToScroll: 2
	      }
	    },
	    {
	      breakpoint: 1200,
	      settings: {
	        //arrows: false,
	        centerMode: true,
	        //centerPadding: '0px',
	        slidesToShow: 3,
	        slidesToScroll: 3
	      }
	    },
	    {
	      breakpoint: 850,
	      settings: {
	        //arrows: false,
	        centerMode: true,
	        //centerPadding: '0px',
	        slidesToShow: 2,
	        slidesToScroll: 2
	      }
	    },
	    {
	      breakpoint: 768,
	      settings: {
	        //arrows: false,
	        centerMode: true,
	        centerPadding: '220px',
	        slidesToShow: 1,
	        slidesToScroll: 1
	      }
	    },
	    {
	      breakpoint: 650,
	      settings: {
	        //arrows: false,
	        centerMode: true,
	        centerPadding: '170px',
	        slidesToShow: 1,
	        slidesToScroll: 1
	      }
	    },
	    {
	      breakpoint: 520,
	      settings: {
	        arrows: false,
	        centerMode: true,
	        centerPadding: '100px',
	        slidesToShow: 1,
	        slidesToScroll: 1
	      }
	    },
	    {
	      breakpoint: 440,
	      settings: {
	        arrows: false,
	        centerMode: true,
	        centerPadding: '25px',
	        slidesToShow: 1,
	        slidesToScroll: 1
	      }
	    }
	  ]
	});

	// big slider bottom on HP
	$('.slider-image-wrapper').slick({
		infinite: true,
		slidesToShow: 1,
		dots: true,
		fade: true,
		speed: 800,
		//appendArrows:$('.images-wrapper .slider-navigation'),
		//appendDots:$('.images-wrapper .slider-navigation'),
	});

	// Autocomplete on filter by tag field
	$('select.select2').each(

		function()
		{
        	var allowClearEnabled = false;

        	if($(this).find('option[value=""]').length)
			{
         		allowClearEnabled = true;
            }

           	$(this).select2(
				{
             		allowClear: true,
					width: 'resolve',
                    //minimumResultsForSearch: 10,
                	//allowClear: allowClearEnabled
                }
			);

		}
	);
	if($('.select2-container').length > 0)
		$('.select2-container').fadeTo("slow", 1);


    // shadow on event sas page
	$('.datepicker-wrapper, .select2-container').on('click', function(event){
		$('.title-wrapper').addClass('active');
		$(this).addClass('input-active');
		hide_searchoverlay(event);
	});

	// init tabs on HP
	$('.news-menu-wrapper ul a').click(function (e) {
	  e.preventDefault()
	  $(this).tab('show')
	})

	// init masonry on HP
	if ($(window).width() > 768) {
		$('.masonry').masonry({
		  itemSelector: '.socialpost',
		  columnWidth: '.socialpost',
		  percentPosition: true
		});
	}

	// init medias gallery in single event
	if($('.img-gallery').length > 0 )
		$('.img-gallery').swipebox();

	// big slider bottom on HP
	$('.partners-slider').slick({
		infinite: true,
		slidesToShow: 5,
		arrows:true,
		autoplay: true,
  		autoplaySpeed: 4000,
  		responsive: [
	    {
	      breakpoint: 768,
	      settings: {
	      	dots:true,
	      	arrows: false,
	        slidesToShow: 2,
	        slidesToScroll: 2
	      }
	    },
	    ]
	});

	// init datepicker in listing page
	if($('.datepicker-wrapper').length > 0){
		$.fn.datepicker.defaults.format = "dd/mm/yyyy";
		$('#fstart').datepicker({
			//format: 'dd/mm/yyyy',
			container: '#datepicker-wrapper-fstart',
			disableEntry: true,
			maxViewMode: "days",
			language: 'fr',
		});
		$('#fend').datepicker({
			//format: 'dd/mm/yyyy',
			container: '#datepicker-wrapper-fend',
			disableEntry: true,
			maxViewMode: "days",
			language: 'fr',
		});
	}

	// animation on hover of event in listing event MAP
	$(".events-wrapper .event").on("hover",
        function()
        {
            var id = $(this).data("occurence");
            evt_to_marker(id,true);
            center_map( map );
        }
    );

	// sticky artist info in single-artist
	if($('.id-artist-inner').length > 0){
		$(".id-artist-inner").stick_in_parent({
		    offset_top:offset + 30,
		});
	}

	//
	$('#gotodiscover, .smoothscroll').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top - 50
        }, 1000);
        return false;
      }
    }
  });

	// "discover more" slider
	$('.slider-events').slick({
		infinite:false,
	  	slidesToShow: 3,
	  	arrows: true,
	  	responsive: [
	    {
	      breakpoint: 768,
	      settings: {
	      	dots:true,
	      	arrows: false,
	        slidesToShow: 2,
	        slidesToScroll: 2
	      }
	    },
	    {
	      breakpoint: 550,
	      settings: {
	      	dots:true,
	      	arrows: false,
	        slidesToShow: 1,
	        slidesToScroll: 1
	      }
	    }
	    ]
	});

	// gallery slider in single event
	$('.slider-images-place').slick({
	  	arrows: true,
	  	adaptiveHeight: false,
	});

	// gallery slider in single event
	$('.image-slide').slick({
	  	arrows: true,
	});

	// gallery en images
    if($('.gallery-wrapper').length > 0){
	   	$('.gallery-wrapper').lightGallery({
	        thumbnail:true,
	            youtubePlayerParams: {
		        modestbranding: 1,
		        showinfo: 0,
		        rel: 0,
		        controls: 0
		    },
		    vimeoPlayerParams: {
		        byline : 0,
		        portrait : 0,
		        //color : 'A90707'
		    },
		    download:false,
	    });

		var $grid = $('.gallery-wrapper').isotope({
			layoutMode: 'masonryHorizontal',
			itemSelector: '.slide-image',
			masonryHorizontal: {
				rowHeight: 240,
				gutter: 2
			},
		});
    }

    // gallery en images HP
    if($('.slider-image-wrapper').length > 0){
        $('.slider-image-wrapper .slick-track').lightGallery({
            thumbnail:true,
            youtubePlayerParams: {
                modestbranding: 1,
                showinfo: 0,
                rel: 0,
                controls: 0
            },
            vimeoPlayerParams: {
                byline : 0,
                portrait : 0,
                //color : 'A90707'
            },
            download:false,
        });
    }
	
	// artists in event single
	
	if($('body').hasClass('single-event') && $(window).width() > 768)
	{		
		var artists_height = parseInt($('.main-img-wrapper').height());
		var content_height = parseInt($('.event-body').height());
		var content_padding_top = parseInt($('.single-event .site-content').css('padding-top'));
		
		if(artists_height > (content_height + content_padding_top))
		{
			$('.event-body').css('min-height',(artists_height - content_padding_top + 100) + 'px');
		}
	}

});


$(window).load(function(){

	// when init slider of events on HP is finished then show it
	$('.slider-soon-wrapper').fadeIn();

	// redo the masonry to give nice effect
	$('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
		$('.masonry').masonry({
		  itemSelector: '.socialpost',
		  columnWidth: '.socialpost',
		  percentPosition: true
		});
	})

	// custom scroll for event listing MAP
	if($(".events-wrapper").length > 0) {
		$(".events-wrapper").mCustomScrollbar({
			setWidth : 480,
	    	axis:"y",
	    	mouseWheel:{ scrollAmount: 150 },
	    	//autoDraggerLength: false,
	    });
	}

	if($(".gallery-track").length > 0) {
		$(".gallery-track").mCustomScrollbar({
			axis:"x",
			contentTouchScroll:true,
			autoDraggerLength: true,
			mouseWheel:{ scrollAmount: 240 },
			scrollButtons:{
				enable: true,
				scrollAmount: 720,
				scrollType: "stepped"
			},
		});
	}

});

})(jQuery);
